import { Component, Inject } from '@angular/core';
import { analytics } from '@app/events/segment/analytics';
import { ItemTags } from '@app/utils/constants';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogModule,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-start-assessment-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './start-assessment-dialog.component.html',
  styleUrl: './start-assessment-dialog.component.css'
})
export class StartAssessmentDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { assessmentUrl: string; assessmentType: ItemTags; },
  ) { }

  onStartAssessment() {
    if (this.data?.assessmentType === 'communication') {
      analytics.track('Checklist Start Communication', { section: 'explore' });
    } else if (this.data?.assessmentType === 'durable') {
      analytics.track('Checklist Start Durable', { section: 'explore' });
    }
  }
}
